import { render, staticRenderFns } from "./AcceptOrder.vue?vue&type=template&id=61abc7d7&scoped=true&"
import script from "./AcceptOrder.vue?vue&type=script&lang=js&"
export * from "./AcceptOrder.vue?vue&type=script&lang=js&"
import style0 from "./AcceptOrder.vue?vue&type=style&index=0&id=61abc7d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61abc7d7",
  null
  
)

export default component.exports